import { render, staticRenderFns } from "./DropdownPage.vue?vue&type=template&id=084cd78f&"
import script from "./DropdownPage.vue?vue&type=script&lang=ts&"
export * from "./DropdownPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports